import { render } from "./SpicyCard.vue?vue&type=template&id=810fa480&scoped=true"
const script = {}

import "./SpicyCard.vue?vue&type=style&index=0&id=810fa480&lang=css"
import "./SpicyCard.vue?vue&type=style&index=1&id=810fa480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810fa480"]])

export default __exports__